import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async ({ orderId, packageId }: { orderId: string; packageId?: string }) =>
      await $fetch<string>('/api/payment-link/paypal/capture', {
        query: {
          orderId,
          ...(packageId && { packageId }),
        },
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
  })
}
